/* eslint-disable quotes */
export type Leaf = {
  title: string;
  href: string;
  imageSrc: string;
  children?: Leaf[];
  titleTag?: string;
  titleColor?: string;
};

export type L2Parent = Leaf & { children: Leaf[] };

export function transformToLeaf(node: BuilderMobileNavChild): Leaf {
  // Destructure necessary properties from the node
  // ? imageSrc shouldn't be optional, but it is in the BuilderMobileNavChild type, likely a quicktype issue
  const { title, href, imageSrc = '', children = [], titleColor, titleTag } = node;

  // Recursively transform the children nodes
  const transformedChildren = children.length > 0 ? children.map(transformToLeaf) : undefined;

  // Construct and return the Leaf object
  return {
    title,
    href,
    imageSrc,
    children: transformedChildren,
    titleColor,
    titleTag,
  };
}

// ? quicktype outputs from for builder output; do not trust implicitly, quicktype isn't perfect
export type BuilderMobileNav = {
  children: BuilderMobileNavChild[];
  id: string;
};

type BuilderMobileNavChild = {
  children?: BuilderMobileNavChild[];
  href: string;
  imageSrc?: string;
  title: string;
  titleColor?: string;
  titleTag?: string;
};
